module.exports = __webpack_public_path__ + "img/NaokoSerino-MerjaWinqvist-KariLønning-Yasuhisa-Kohyama.a3ac00a9.jpg";